import React, { useState } from 'react';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import TextSearchInput from '../../../components/fields/TextInput/TextSearchInput';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import ApplicationsDTO from '../../../dto/ApplicationsDTO';
import { APPLICATION_FILE_FORMAT_LIST, INTERNAL_APPLICATION_STATUS_LIST, PROCEDURE_TYPE_LIST } from '../../../configs';
import { loadUserList } from '../../User/actions';
import CustomSelectInputWithHelper from '../../../components/fields/SelectInput/CustomSelectInputWithHelper';
import RangeDatePicker from '../../../components/fields/RangeDatePicker/RangeDatePicker';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FilterModal from '../../FilterTemplate/components/FilterModal';
import { PAGE_TYPE } from '../../FilterTemplate/components/filter-settings';
import ExportInterface from '../../System/components/ExportInterface';

export default function ApplicationFilter(props) {
  const {
    control,
    search,
    procedureText,
    isDraft,
    searchParams,
    defaultFilterValues,
    selected,
    getValues = () => {},
    reset = () => {},
    handleSetUrlParams = () => {},
    getInputPropsWithSearch = () => {},
    setSearchParams = () => {},
    handleCreate = () => {},
  } = props;
  const [isOpenFilter, setOpenFilter] = useState(false);

  const DTO = new ApplicationsDTO();
  const attributes = DTO.getAttributesByName();
  return (
    <FilterRow>
      <FieldDTO
        control={control}
        component={TextSearchInput}
        dtoObject={{
          name: 'search',
          type: String,
          labelKey: 'search',
        }}
        className="no-border"
        inputProps={{
          value: search || getValues('search') || '',
          onChange: e => handleSetUrlParams({ procedure: procedureText, search: e.target.value || '' }),
        }}
      />
      { isDraft
        ? (
          <FieldDTO
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.procedure}
            usePortal
            multiple
            className="no-border"
            options={PROCEDURE_TYPE_LIST}
            portalClassName="procedure-selector"
          />
        )
        : (
          <FieldDTO
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.procedure}
            usePortal
            multiple
            className="no-border"
            options={PROCEDURE_TYPE_LIST}
            inputProps={getInputPropsWithSearch(getValues, searchParams, setSearchParams, 'procedure', [])}
            portalClassName="procedure-selector"
          />
        )}
      <FieldDTO
        control={control}
        component={CustomSelectInputWithHelper}
        dtoObject={attributes.executor_id}
        usePortal
        className="no-border"
        portalClassName="executor-selector"
        loadAction={loadUserList}
        optionFormatter={item => ({ value: item.id, name: item.full_name })}
        filterName="full_name"
        addPlaceholder
      />
      { !isDraft
        ? (
          <FieldDTO
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.status}
            usePortal
            placeholder="Статус"
            className="no-border"
            options={INTERNAL_APPLICATION_STATUS_LIST}
            addPlaceholder
            multiple
          />
        ) : null }
      <FieldDTO
        control={control}
        component={RangeDatePicker}
        dtoObject={attributes.created_at}
        usePortal
        placeholder="Дата подачи"
        changeFormat="YYYY-MM-DD"
        className="no-border"
      />
      <div className="filter-sep" />
      <ExportInterface page="applications" exporter="applications" getValues={getValues} selected={selected} types={APPLICATION_FILE_FORMAT_LIST} />
      <div className="filter-sep" />
      <Button variant="second" onClick={() => setOpenFilter(true)}>
        <Icons customIcon className="file-download" width={24} height={24} icon="filter" />
      </Button>
      { !isDraft
        ? (
          <>
            <div className="filter-sep" />
            <Button variant="second" onClick={handleCreate}>
              <Icons
                customIcon
                className="file-download"
                width={24}
                height={24}
                icon="plus"
              />
            </Button>
          </>
        ) : null }
      {isOpenFilter
        ? (
          <FilterModal
            control={control}
            onClose={() => setOpenFilter(false)}
            getValues={getValues}
            reset={reset}
            defaultValues={defaultFilterValues}
            page={PAGE_TYPE.APPLICATION}
          />
        )
        : null}
    </FilterRow>
  );
}
